import TextInput, { TextInputCurrency } from './TextInput'

export {
    TextInputCurrency,
}

export default TextInput
